function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import customerCareKeys from '../../../../locales/keys';
import { ENTITLEMENT_CONTEXT_TYPES } from '../../../../customercare.constants';
var EntitlementUsageChartController = /*#__PURE__*/function () {
  function EntitlementUsageChartController($timeout) {
    _classCallCheck(this, EntitlementUsageChartController);
    Object.assign(this, {
      $timeout: $timeout,
      customerCareKeys: customerCareKeys,
      ENTITLEMENT_CONTEXT_TYPES: ENTITLEMENT_CONTEXT_TYPES,
      isGroupModalOpen: false
    });
  }
  return _createClass(EntitlementUsageChartController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.groupedEntitlementsPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this.groupedEntitlementsPopupApi = event.api;
        }
      };
    }
  }, {
    key: "openEntitlementsModal",
    value: function openEntitlementsModal(event) {
      var _this2 = this;
      event.stopPropagation();
      this.isGroupModalOpen = true;
      this.$timeout(function () {
        _this2.groupedEntitlementsPopupApi.open();
      });
    }
  }, {
    key: "closeGroupEntitlementModal",
    value: function closeGroupEntitlementModal() {
      this.groupedEntitlementsPopupApi.close();
      this.isGroupModalOpen = false;
    }
  }]);
}();
export default {
  bindings: {
    currencyCode: '<?',
    entitlement: '<',
    hideChartLegend: '<?',
    serviceIdentifier: '<?',
    showExpirationDate: '<?',
    showTotalUsed: '<?'
  },
  controller: EntitlementUsageChartController,
  template: require('./entitlement.usage.chart.template.html')
};